import { getMinMaxIntervalsDy } from "./getMinMaxIntervals.js";
import { getPeakFromIntervals } from "./getPeaksFromIntervals.js";
import { xGetCrossZeroPoints } from "./xGetCrossZeroPoints.js";
/**
 * Detect peaks using zero-crossings of the first derivative.
 * @param input - Spectrum values and its first/second derivatives.
 * @returns The detected peaks.
 */
export function firstDerivative(input) {
    const { y, x, dY, dX, yData, yThreshold, ddY } = input;
    const crossDy = xGetCrossZeroPoints(input);
    const { intervalL, intervalR } = getMinMaxIntervalsDy(y, x, dY, dX);
    return getPeakFromIntervals({
        minData: crossDy,
        intervalL,
        intervalR,
        x,
        yData,
        yThreshold,
        ddY,
    });
}
//# sourceMappingURL=firstDerivative.js.map